// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SocialCard.css */
/* Uses utilities: .list-reset, .text-wrap-anywhere, .flex, .gap-sm, .gap-lg, .rounded-sm */

.socialList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--spacing-xxs);
  justify-content: flex-start;
}

.socialItem {
  display: flex;
  align-items: center;
}

.socialItem a {
  color: var(--color-primary);
  text-decoration: none;
  display: flex;
  align-items: center;
  min-height: var(--min-touch-target);
  padding: var(--spacing-xxs); 
  border-radius: var(--border-radius-base);
  transition: background-color var(--animation-duration) ease;
  position: relative;
  flex: 1;
  min-width: 0;
}

.socialItem a:hover,
.socialItem a:focus {
  text-decoration: underline;
  background-color: rgba(124, 77, 255, 0.1);
}

/* Screen reader only external link indication */
.socialItem a[href^="http"]:after {
  content: " (external link)";
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.socialIcon {
  width: var(--icon-base);
  height: var(--icon-base);
  border-radius: var(--border-radius-base);
  background: var(--color-card-bg);
  flex-shrink: 0;
}

.socialCard__more-button {
  display: none;
}

@media (max-width: 1000px) {
  .socialCard .socialList {
    display: grid;
    grid-template-columns: repeat(5, max-content);
    justify-content: flex-start;
  }

  .socialCard[data-mobile-expanded="true"] .socialList {
    grid-template-columns: repeat(3, max-content);
  }

  .socialCard[data-mobile-expanded="false"] .socialItem:nth-child(n + 11) {
    display: none;
  }

  .socialCard__more-button {
    display: inline-flex;
    margin-top: var(--spacing-xs);
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--color-primary, #7C4DFF);
    font: inherit;
    font-weight: 600;
    cursor: pointer;
  }

  .socialCard[data-mobile-expanded="true"] .socialCard__more-button {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/SocialCard.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB,2FAA2F;;AAE3F;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,2BAA2B;EAC3B,wCAAwC;EACxC,2DAA2D;EAC3D,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;;AAEA;;EAEE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA,gDAAgD;AAChD;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;EACxC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,6CAA6C;IAC7C,2BAA2B;EAC7B;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,6BAA6B;IAC7B,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,oCAAoC;IACpC,aAAa;IACb,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* SocialCard.css */\n/* Uses utilities: .list-reset, .text-wrap-anywhere, .flex, .gap-sm, .gap-lg, .rounded-sm */\n\n.socialList {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: var(--spacing-xxs);\n  justify-content: flex-start;\n}\n\n.socialItem {\n  display: flex;\n  align-items: center;\n}\n\n.socialItem a {\n  color: var(--color-primary);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  min-height: var(--min-touch-target);\n  padding: var(--spacing-xxs); \n  border-radius: var(--border-radius-base);\n  transition: background-color var(--animation-duration) ease;\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n\n.socialItem a:hover,\n.socialItem a:focus {\n  text-decoration: underline;\n  background-color: rgba(124, 77, 255, 0.1);\n}\n\n/* Screen reader only external link indication */\n.socialItem a[href^=\"http\"]:after {\n  content: \" (external link)\";\n  position: absolute;\n  left: -10000px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n\n.socialIcon {\n  width: var(--icon-base);\n  height: var(--icon-base);\n  border-radius: var(--border-radius-base);\n  background: var(--color-card-bg);\n  flex-shrink: 0;\n}\n\n.socialCard__more-button {\n  display: none;\n}\n\n@media (max-width: 1000px) {\n  .socialCard .socialList {\n    display: grid;\n    grid-template-columns: repeat(5, max-content);\n    justify-content: flex-start;\n  }\n\n  .socialCard[data-mobile-expanded=\"true\"] .socialList {\n    grid-template-columns: repeat(3, max-content);\n  }\n\n  .socialCard[data-mobile-expanded=\"false\"] .socialItem:nth-child(n + 11) {\n    display: none;\n  }\n\n  .socialCard__more-button {\n    display: inline-flex;\n    margin-top: var(--spacing-xs);\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: var(--color-primary, #7C4DFF);\n    font: inherit;\n    font-weight: 600;\n    cursor: pointer;\n  }\n\n  .socialCard[data-mobile-expanded=\"true\"] .socialCard__more-button {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
